
import styled from 'styled-components';
export const Button = styled.div`
   position: fixed; 
   width: 100%;
   bottom: 60px;
   left: 95%;
   height: 20px;
   font-size: 2rem;
   z-index: 1;
   cursor: pointer;
   color: #f9ab00;
   i{
      background-color: ${({theme})=>theme.background};
   }
`